import React, { useEffect } from 'react';
import { Grid, Typography } from 'housecall-ui';

import { trackButtonClicked } from '../../src/hooks/useEventTracking';
import { FormContent } from '../components/FormContent';
import { FormSkeleton } from '../components/FormSkeleton';
import { useLeadCaptureSettings } from '../hooks/useLeadCaptureSettings';

import { ErrorPage } from './ErrorPage';

export const FormPage = () => {
  const { data, isLoading, isError } = useLeadCaptureSettings();
  const [isFocusEventSent, setIsFocusEventSent] = React.useState(false);

  useEffect(() => {
    const handleFocusClick = () => {
      if (!isFocusEventSent) {
        setIsFocusEventSent(true);
        trackButtonClicked({ buttonName: 'lf_focus' });
      }
    };

    // Attach the click event listener to the document
    document.addEventListener('click', handleFocusClick);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleFocusClick);
    };
  }, [isFocusEventSent]);

  if (isLoading) {
    return <FormSkeleton />;
  }

  if (isError) {
    return <ErrorPage />;
  }

  return (
    <Grid container spacing={1} direction="column">
      <Grid item xs={12}>
        <Typography variant="h6" style={{ wordWrap: 'break-word' }}>
          {data?.text_fields.headline}
        </Typography>
        <Typography variant="body1">{data?.text_fields.body_text}</Typography>
      </Grid>
      <FormContent />
    </Grid>
  );
};
